module.exports = "<img src=\"/img/verve2017.png\" alt=\"Verve 2017\" class=\"logo on-page-{{vm.current}}\" />\r\n<ul class=\"lang-select\">\r\n\t<li ng-repeat=\"lang in vm.langs\" ng-click=\"vm.set(lang)\">{{lang}}</li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/index/templates/lang.template.html
// module id = 22
// module chunks = 0